<script setup lang="ts">
import { Eye, EyeOff, LockKeyhole } from '@lucide/vue'

defineProps<{
  label: string
  name: string
  autocomplete: string
  placeholder?: string
  minlength?: string | number
  maxlength?: string | number
}>()
const model = defineModel<string>({ required: true })
const visible = ref(false)
const input = useTemplateRef<HTMLInputElement>('input')
defineExpose({ focus: () => input.value?.focus() })
</script>

<template>
  <label class="auth-field">
    <span class="auth-label">{{ label }}</span>
    <span class="auth-input-wrap auth-password-wrap">
      <LockKeyhole
        :size="18"
        aria-hidden="true"
      />
      <input
        ref="input"
        v-model="model"
        :name="name"
        :type="visible ? 'text' : 'password'"
        :autocomplete="autocomplete"
        :placeholder="placeholder"
        :minlength="minlength"
        :maxlength="maxlength"
        required
      />
      <button
        type="button"
        :aria-label="visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'"
        :title="visible ? 'Masquer' : 'Afficher'"
        @click="visible = !visible"
      >
        <EyeOff
          v-if="visible"
          :size="18"
          aria-hidden="true"
        /><Eye
          v-else
          :size="18"
          aria-hidden="true"
        />
      </button>
    </span>
  </label>
</template>
